import { IS_LOCAL_MODE } from "../Constants";

export const llog = (...msg) => {
  if (IS_LOCAL_MODE) {
    const prefix = "LocalMode: ";
    if (msg.length === 1) {
      console.log(prefix, msg[0]);
    } else if (msg.length === 2) {
      console.log(prefix, msg[0], msg[1]);
    }
  }
};
